import storage from '@/utils/localstorage'
// import api from '../../api/login/index'
// import { setUuid } from '@/utils/analytics'

const SITE_ENV =
  document.querySelector('html')?.getAttribute('SITE_ENV') ||
  process.env.VUE_APP_SITE_ENV ||
  (window as any).SITE_ENV

const state = {
  token: '' || storage.getLocalStorage('token'),
  phone: '' || storage.getLocalStorage('phone'),
  isOpenLoginPanel: false,
  macId: '',
  uuid: '',
  language:
    storage.getLocalStorage('language') ||
    (SITE_ENV !== 'intl' ? 'ZH_CN' : 'EN'),
  siteEnv: SITE_ENV,
  collectToken: { web_id: '', ssid: '' },
  userInfo: storage.getLocalStorage('userInfo') || {},
  chatToken:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJkZW1vQG1vYnZvaS5jb20iLCJleHAiOjE2ODA5NTE4OTI1Nzh9.Z3ywPvRGN-tSRMldMGwhCz5YyZYIAsXatGL0NWLXdFI',
  ifreamData: null,
  isIfreamMode: false,
  wwToken: ''
}
const mutations = {
  setUuid(state: any, data: any) {
    state.uuid = data
  },
  setMacId(state: any, data: any) {
    state.macId = data
  },
  setLanguage(state: any, data: any) {
    state.language = data
    storage.setLocalStorage('language', data)
  },
  setCollectToken(state: any, data: any) {
    state.collectToken = data
  },
  setToken(state: any, data: any) {
    state.token = data.token
    storage.setLocalStorage('token', data.token)
  },
  setChatToken(state: any, value: any) {
    state.chatToken = value
  },
  removeToken(state: any) {
    storage.removeLocalStorage('token')
    storage.removeLocalStorage('phone')
    state.token = ''
    state.phone = ''
    state.userInfo = {}
  },
  setUserInfo(state: any, data: any) {
    state.userInfo = data
    state.phone = data.phone
    storage.setLocalStorage('phone', data.phone)
  },
  setOpenLoginPanel(state: any, data: any) {
    state.isOpenLoginPanel = data
  },
  setIfreamData(state: any, data: any) {
    state.ifreamData = data
  },
  setIfreamMode(state: any, data: boolean) {
    state.isIfreamMode = data
  },
  setwwToken(state: any, data: string) {
    state.wwToken = data
  }
}

const actions = {
  // async Login(
  //   { commit, dispatch, state }: any,
  //   userInfo: { phone: string; code: any }
  // ) {
  //   const res: any = await api.login.login(userInfo)
  //   if (res.code === 200) {
  //     console.log('logon', res)
  //     commit('setToken', { token: res.data })
  //     dispatch('getUserInfo')
  //   }
  //   return res
  // },
  async getUserInfo({ commit }: any) {
    // const res: any = await api.login.getUserInfo({})
    // if (res.code == 200) {
    //   commit('setUserInfo', res.data)
    // }
    // return res
  },
  Logout({ commit }: any) {
    commit('removeToken')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
